<script lang="ts">
	//Design system components
	import { ButtonV2, Stack, Text } from '@Shelly/shelly-design-system';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	//Stores
	import { user_data } from 'src/stores/account/user';
	//Services
	import { format } from 'svelte-i18n';
	//Components
	import CarPlayWizard from './CarPlayWizardV2.svelte';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';

	let showModal = false;

	const toggleEdit = () => {
		showModal = !showModal;
	};
	//this component is used mostly as entry point for the wizard and as a check for installers access
</script>

<Stack direction="column" directionMobile="row" align="between" alignMobile="none" gap="m">
	<ButtonV2 variant="primary" disabled={$user_data?.installer} size="m" on:click={toggleEdit}>
		{capFirstChar($format('process_edit'))}
	</ButtonV2>
</Stack>
{#if showModal}
	<CarPlayWizard bind:showModal />
{/if}
{#if $user_data?.installer}
	<Text class="text-color-muted mt-m">
		{capFirstChar(
			$format('text_installer_disabled', {
				default: 'off limits for installers',
			}),
		)}
	</Text>
{/if}
